"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APQRCode = _interopRequireDefault(require("../../../common/APQRCode/APQRCode"));
var _APIcon = _interopRequireDefault(require("../../../common/APIcon"));
var _Spinner = _interopRequireDefault(require("../../../common/Spinner/Spinner"));
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _clipboardHelper = _interopRequireDefault(require("../../../../helpers/clipboardHelper"));
var _destinationTagHelper2 = _interopRequireDefault(require("../../../../helpers/destinationTagHelper"));
require("./CryptoWalletDepositWorkflowComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var baseClasses = (0, _cssClassesHelper.getBEMClasses)('cryptowallet-deposit');
var CryptoWalletDepositWorkflowComponent = /*#__PURE__*/function (_React$Component) {
  function CryptoWalletDepositWorkflowComponent() {
    var _this;
    _classCallCheck(this, CryptoWalletDepositWorkflowComponent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CryptoWalletDepositWorkflowComponent, [].concat(args));
    _defineProperty(_this, "state", {
      currentIndex: null
    });
    _defineProperty(_this, "handlePrev", function () {
      _this.setState(function (s) {
        var _s$currentIndex;
        return {
          currentIndex: Math.max(0, ((_s$currentIndex = s.currentIndex) !== null && _s$currentIndex !== void 0 ? _s$currentIndex : 0) - 1)
        };
      });
    });
    _defineProperty(_this, "handleNext", function () {
      var total = (_this.props.addressList || []).length;
      _this.setState(function (s) {
        var _s$currentIndex2;
        return {
          currentIndex: Math.min(total - 1, ((_s$currentIndex2 = s.currentIndex) !== null && _s$currentIndex2 !== void 0 ? _s$currentIndex2 : 0) + 1)
        };
      });
    });
    _defineProperty(_this, "handleGenerate", function () {
      var _this$props = _this.props,
        generateNewDepositAddress = _this$props.generateNewDepositAddress,
        product = _this$props.product,
        accountProviderId = _this$props.accountProviderId;
      if (!product || !product.ProductId) return;
      generateNewDepositAddress(product.ProductId, accountProviderId);
    });
    return _this;
  }
  _inherits(CryptoWalletDepositWorkflowComponent, _React$Component);
  return _createClass(CryptoWalletDepositWorkflowComponent, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var prevLen = (prevProps.addressList || []).length;
      var nextLen = (this.props.addressList || []).length;
      var providerChanged = prevProps.accountProviderId !== this.props.accountProviderId;
      if (providerChanged) {
        this.setState({
          currentIndex: null
        });
        return;
      }
      if (nextLen && nextLen !== prevLen) {
        // Initial load (0 → N) lands on the first/oldest;
        // Generate (N → N+1) lands on the new last.
        var targetIndex = prevLen === 0 ? 0 : nextLen - 1;
        this.setState({
          currentIndex: targetIndex
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        t = _this$props2.t,
        addressList = _this$props2.addressList,
        product = _this$props2.product,
        showSnack = _this$props2.showSnack,
        isLoading = _this$props2.isLoading,
        error = _this$props2.error;
      var currentIndex = this.state.currentIndex;

      // Protocol prefix for the QR Code, lowercase name with no spaces.
      var depositType = product.ProductFullName.toLowerCase().replace(/\W/g, '');
      var total = (addressList || []).length;
      var safeIndex = total ? Math.min(Math.max(currentIndex !== null && currentIndex !== void 0 ? currentIndex : 0, 0), total - 1) : null;
      var selectedAddress = safeIndex !== null ? addressList[safeIndex] : '';
      var atFirst = total <= 1 || safeIndex === 0;
      var atLast = total <= 1 || safeIndex === total - 1;
      var _destinationTagHelper = (0, _destinationTagHelper2["default"])(selectedAddress),
        address = _destinationTagHelper.address,
        dt = _destinationTagHelper.dt,
        memo = _destinationTagHelper.memo;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('wrapper')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Please read the instructions below')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('description')
      }, t('Depositing cryptocurrency into the exchange is safe and easy. The address below can always be used to deposit cryptocurrency into your account.')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('frame')
      }, selectedAddress && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('qr-code')
      }, /*#__PURE__*/_react["default"].createElement(_APQRCode["default"], {
        value: "".concat(depositType, ":").concat(selectedAddress),
        className: baseClasses('qrcode')
      })), /*#__PURE__*/_react["default"].createElement("div", null, selectedAddress && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Address'), ":"), /*#__PURE__*/_react["default"].createElement("div", {
        "data-test": "Address",
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(address);
          showSnack(t('The address has been copied to the clipboard.'));
        },
        className: baseClasses('address')
      }, address, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: baseClasses('copy-icon')
      })), dt && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Be sure to include this destination tag:')), /*#__PURE__*/_react["default"].createElement("div", {
        "data-test": "Destination tag",
        className: baseClasses('address'),
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(dt);
          showSnack(t('The destination tag has been copied to the clipboard.'));
        }
      }, dt, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: baseClasses('copy-icon')
      }))), memo && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('title')
      }, t('Be sure to include this memo tag:')), /*#__PURE__*/_react["default"].createElement("div", {
        "data-test": "Memo tag",
        className: baseClasses('address'),
        onClick: function onClick() {
          (0, _clipboardHelper["default"])(memo);
          showSnack(t('The memo tag has been copied to the clipboard.'));
        }
      }, memo, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "copy",
        customClass: baseClasses('copy-icon')
      }))), total > 1 && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('pager')
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handlePrev,
        disabled: atFirst,
        className: baseClasses('pager-button', atFirst ? 'disabled' : ''),
        "aria-label": t('Previous address')
      }, "\u2039"), /*#__PURE__*/_react["default"].createElement("span", {
        className: baseClasses('pager-counter')
      }, "".concat(safeIndex + 1, " / ").concat(total)), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handleNext,
        disabled: atLast,
        className: baseClasses('pager-button', atLast ? 'disabled' : ''),
        "aria-label": t('Next address')
      }, "\u203A"))), !error && /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        onClick: this.handleGenerate,
        disabled: isLoading || !product.ProductId,
        className: baseClasses('generate-button')
      }, t('Generate new address')), isLoading && /*#__PURE__*/_react["default"].createElement(_Spinner["default"], {
        isInline: true,
        text: t('Loading url...'),
        customClass: baseClasses
      }), error && /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('error')
      }, t(error)), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('description')
      }, t('Your account will automatically update after the cryptocurrency network confirms your transaction.')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('description')
      }, t('The confirmation may take up to 1 hour.')), /*#__PURE__*/_react["default"].createElement("div", {
        className: baseClasses('description')
      }, /*#__PURE__*/_react["default"].createElement("div", null, t('1) Send cryptocurrency to this address')), /*#__PURE__*/_react["default"].createElement("div", null, t('2) Your deposit will automatically be processed'))))));
    }
  }]);
}(_react["default"].Component);
_defineProperty(CryptoWalletDepositWorkflowComponent, "propTypes", {
  addressList: _propTypes["default"].arrayOf(_propTypes["default"].string),
  isLoading: _propTypes["default"].bool,
  error: _propTypes["default"].string,
  showSnack: _propTypes["default"].func,
  generateNewDepositAddress: _propTypes["default"].func.isRequired,
  accountProviderId: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  product: _propTypes["default"].shape({
    Product: _propTypes["default"].string,
    ProductId: _propTypes["default"].number,
    ProductFullName: _propTypes["default"].string,
    ProductType: _propTypes["default"].string
  })
});
_defineProperty(CryptoWalletDepositWorkflowComponent, "defaultProps", {
  addressList: [],
  isLoading: false,
  error: '',
  product: {
    Product: '',
    ProductId: 0,
    ProductFullName: '',
    ProductType: ''
  }
});
var _default = exports["default"] = (0, _reactI18next.withTranslation)('user')(CryptoWalletDepositWorkflowComponent);